export enum DeviceStatusCheck {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
